import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CompletedStyles = styled.div`
  .completed-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .completed-text {
    text-align: center;
    span,
    a {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    p {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .remember-text,
  .media-text {
    text-align: center;
    margin: 16px 0 16px 0;
    font-size: 16px;
    line-height: 24px;
    padding-top: 24px;
  }
  .vas-button {
    background-color: ${(props) => props.theme.primary.primary50};
    color: #ffffff;
    box-shadow: none;
    padding: 18px 24px;
    height: 56px;
    min-width: 56px;
    font-size: 16px;
    line-height: 16px;
    &:hover {
      background-color: ${(props) => props.theme.primary.primary70};
      box-shadow: none;
    }
  }
  .vas-button.Mui-disabled {
    background-color: ${theme.greys.grey010};
    color: ${theme.greys.grey050};
  }
  .vas-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 36px;
  }
`;
